module["exports"] = ['gmail.com', 'yahoo.com', 'gmail.co.id', 'yahoo.co.id'];